import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'filter' })
@Injectable()
export class FilterPipe implements PipeTransform {
  public transform(items: any[], field: string, value: string | number): any[] {
    if (!items) { return []; }
    if (!value || value.toString().length === 0) { return items; }
    return items.filter(it =>
      it[field].toString().toLowerCase().indexOf(value.toString().toLowerCase()) !== -1);
  }
}
